/**
 * @generated SignedSource<<832cb0ca05b4c29680da26b6dca1469f>>
 * @relayHash b4e03b15be6a814c8cff18ca1451d20f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4415d0b1ab234ce7d01399eb3698f9271644ab95605bfc662594739a4f108021

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConnectedToIssueAggQuery$variables = {
  cloudId: string;
  consistentRead?: boolean | null;
  includeDesignPanelData: boolean;
  includeReleasesPanelDevOpsData: boolean;
  includeWhiteboardsCountInAttachmentConsolidation: boolean;
  isAnonymous: boolean;
  isJsmIncidentCommandCenterEnabled: boolean;
  issueKey: string;
  siteAri: string;
  workItemModernizationEnabled: boolean;
};
export type ConnectedToIssueAggQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly incidentCommandCenterFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"IssueLayoutWithIssueLayoutState_shouldShowIncidentCommandCenter">;
      } | null;
      readonly statusPagesIncidentCommandCenterFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ChildrenIssuesSection_shouldShowIncidentCommandCenter">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ConfluenceContentV2Whiteboards" | "IncidentOverviewTabContent_connectedToIssueFragment" | "ResourcesSectionWhiteboardsCount">;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CompactLayoutItemsSection_connectedToQuery" | "DesignSectionDesignPanelWrapper" | "DetailsPanelsSection_connectedToQuery" | "WorkItemLayout_connectedAggData">;
};
export type ConnectedToIssueAggQuery = {
  response: ConnectedToIssueAggQuery$data;
  variables: ConnectedToIssueAggQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": isJsmIncidentCommandCenterIncidentSummaryEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx": isJsmIncidentCommandCenterIncidentTimelineEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": removeDesignProviderTypeFilter_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": removeCtiaqConfigState_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx: {
    readonly get: () => boolean;
  };
});

import removeDesignProviderTypeFilter_provider from '@jira/platform__graphql-relay-provider/src/IsRemoveJswddFetchOperationEnabledRelayProvider';
import isJsmIncidentCommandCenterIncidentSummaryEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmIncidentCommandCenterIncidentSummaryRelayProvider';
import isJsmIncidentCommandCenterIncidentTimelineEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmIncidentCommandCenterIncidentTimelineRelayProvider';
import removeCtiaqConfigState_provider from '@jira/platform__graphql-relay-provider/src/RemoveCtiaqConfigStateRelayProvider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "consistentRead"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDesignPanelData"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReleasesPanelDevOpsData"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWhiteboardsCountInAttachmentConsolidation"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmIncidentCommandCenterEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workItemModernizationEnabled"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = [
  (v10/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 900
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v17 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v18 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "serviceId"
  },
  (v15/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "descriptionList"
},
v21 = {
  "kind": "ScalarField",
  "name": "description"
},
v22 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v23 = {
  "kind": "ScalarField",
  "name": "category"
},
v24 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "type"
},
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v28 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v29 = {
  "kind": "ScalarField",
  "name": "url"
},
v30 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "siteAri"
},
v31 = [
  (v30/*: any*/)
],
v32 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issueByKey",
        "plural": false,
        "selections": [
          {
            "args": (v24/*: any*/),
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentConnection",
            "kind": "LinkedField",
            "name": "deployments",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalDeploymentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "devOpsState",
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "alias": "devOpsLastUpdated",
                            "kind": "ScalarField",
                            "name": "lastUpdated"
                          },
                          {
                            "concreteType": "DevOpsEnvironment",
                            "kind": "LinkedField",
                            "name": "environment",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v22/*: any*/)
                            ]
                          }
                        ],
                        "type": "DeploymentSummary"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "externalState",
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "alias": "externalLastUpdated",
                            "kind": "ScalarField",
                            "name": "lastUpdated"
                          },
                          {
                            "concreteType": "ExternalEnvironment",
                            "kind": "LinkedField",
                            "name": "environment",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v22/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalDeployment"
                      },
                      (v16/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ],
            "storageKey": "deployments(first:100)"
          },
          {
            "args": (v24/*: any*/),
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagConnection",
            "kind": "LinkedField",
            "name": "featureFlags",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalFeatureFlagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v22/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": "devOpsSummary",
                            "concreteType": "DevOpsFeatureFlagSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "rolloutPercentage"
                              },
                              (v29/*: any*/)
                            ]
                          }
                        ],
                        "type": "DevOpsFeatureFlag"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v22/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": "externalSummary",
                            "concreteType": "ExternalFeatureFlagSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "concreteType": "ExternalFeatureFlagStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "ExternalFeatureFlagRollout",
                                    "kind": "LinkedField",
                                    "name": "rollout",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "percentage"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "ExternalProvider",
                            "kind": "LinkedField",
                            "name": "provider",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/)
                            ]
                          }
                        ],
                        "type": "ExternalFeatureFlag"
                      },
                      (v16/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ],
            "storageKey": "featureFlags(first:100)"
          },
          {
            "concreteType": "GraphStoreV2SimplifiedJiraWorkItemLinksExternalRemoteLinkConnection",
            "kind": "LinkedField",
            "name": "remoteLinks",
            "plural": false,
            "selections": [
              (v17/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "DevOps",
    "kind": "LinkedField",
    "name": "devOps",
    "plural": false,
    "selections": [
      {
        "args": (v31/*: any*/),
        "concreteType": "DevOpsProviders",
        "kind": "LinkedField",
        "name": "providers",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevOpsFeatureFlagProvider",
            "kind": "LinkedField",
            "name": "featureFlagProviders",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "name": "createFeatureFlagTemplateUrl"
              },
              {
                "kind": "ScalarField",
                "name": "connectFeatureFlagTemplateUrl"
              }
            ]
          }
        ]
      }
    ]
  }
],
v33 = {
  "kind": "ScalarField",
  "name": "checkAuth"
},
v34 = {
  "kind": "ScalarField",
  "name": "getEntityByUrl"
},
v35 = {
  "kind": "ScalarField",
  "name": "status"
},
v36 = [
  {
    "concreteType": "DevOpsDesignProvider",
    "kind": "LinkedField",
    "name": "designProviders",
    "plural": true,
    "selections": [
      (v12/*: any*/),
      (v15/*: any*/),
      {
        "concreteType": "DevOpsSupportedActions",
        "kind": "LinkedField",
        "name": "supportedActions",
        "plural": false,
        "selections": [
          (v33/*: any*/),
          (v34/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "handledDomainName"
      },
      {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v10/*: any*/)
            ],
            "concreteType": "JiraAppConfigState",
            "kind": "LinkedField",
            "name": "configState",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigStateConnection",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v35/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "workspaceId"
                      }
                    ]
                  }
                ]
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v37 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ConnectedToIssueAggQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v11/*: any*/),
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ConfluenceContentV2Whiteboards"
                },
                {
                  "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ResourcesSectionWhiteboardsCount"
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "IncidentOverviewTabContent_connectedToIssueFragment"
                },
                {
                  "condition": "isJsmIncidentCommandCenterEnabled",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "IssueLayoutWithIssueLayoutState_shouldShowIncidentCommandCenter"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "incidentCommandCenterFragment"
                    },
                    {
                      "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "ChildrenIssuesSection_shouldShowIncidentCommandCenter"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      "kind": "AliasedInlineFragmentSpread",
                      "name": "statusPagesIncidentCommandCenterFragment"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW"
      },
      {
        "condition": "includeReleasesPanelDevOpsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CompactLayoutItemsSection_connectedToQuery"
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsPanelsSection_connectedToQuery"
          }
        ]
      },
      {
        "condition": "includeDesignPanelData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DesignSectionDesignPanelWrapper"
          }
        ]
      },
      {
        "condition": "workItemModernizationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "includeDesignPanelData",
                "variableName": "includeDesignPanelData"
              }
            ],
            "kind": "FragmentSpread",
            "name": "WorkItemLayout_connectedAggData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx"
      }
    ],
    "kind": "Operation",
    "name": "ConnectedToIssueAggQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "condition": "isAnonymous",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                    "kind": "LinkedField",
                    "name": "whiteboards",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "concreteType": "ConfluenceWhiteboardLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "base"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "webUi"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ConfluenceUserInfo",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "accountStatus"
                                          },
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                          },
                                          (v12/*: any*/)
                                        ]
                                      },
                                      (v12/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "title"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "whiteboardId"
                                  }
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          },
                          (v12/*: any*/)
                        ]
                      },
                      (v17/*: any*/),
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "whiteboards(first:900)"
                  },
                  {
                    "args": (v13/*: any*/),
                    "handle": "connection",
                    "key": "ConfluenceContentV2Whiteboards__whiteboards",
                    "kind": "LinkedHandle",
                    "name": "whiteboards"
                  }
                ]
              },
              {
                "condition": "includeWhiteboardsCountInAttachmentConsolidation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "args": (v13/*: any*/),
                        "concreteType": "GraphStoreSimplifiedIssueToWhiteboardConnection",
                        "kind": "LinkedField",
                        "name": "whiteboards",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedIssueToWhiteboardEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "createdAt"
                              }
                            ]
                          }
                        ],
                        "storageKey": "whiteboards(first:900)"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "incidentSuggestion",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "incidentSummaryDescription"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "probableRCADescription"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "suggestedActions",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketSummary"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketDescription"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedProblemTicketRootCause"
                                  },
                                  {
                                    "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedProblemTicketAffectedServices",
                                    "plural": true,
                                    "selections": (v19/*: any*/)
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedProblemTicket"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "suggestedIsMajorIncident"
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedMajorIncident"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedUser",
                                    "kind": "LinkedField",
                                    "name": "suggestedAssignees",
                                    "plural": true,
                                    "selections": [
                                      (v14/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedAssignees"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedUser",
                                    "kind": "LinkedField",
                                    "name": "suggestedResponders",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "ari"
                                      },
                                      (v15/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedResponders"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedPriorityDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedPriority",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                      },
                                      (v15/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedPriority"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedSeverityDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedSeverity",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "severityId"
                                      },
                                      (v15/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedSeverity"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "concreteType": "AIOpsIncidentSuggestedAutomationRule",
                                    "kind": "LinkedField",
                                    "name": "suggestedAutomationRules",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "ruleId"
                                      },
                                      (v15/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "resourceRuleScopes"
                                      },
                                      {
                                        "concreteType": "AIOpsAutomationRuleUserPrompt",
                                        "kind": "LinkedField",
                                        "name": "userInputPrompts",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "variableName"
                                          },
                                          (v22/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "inputType"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "required"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "defaultValue"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "AIOpsIncidentSuggestedRcaWithAutomation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "AIOpsIncidentAffectedServiceDetail",
                                    "kind": "LinkedField",
                                    "name": "suggestedAffectedServices",
                                    "plural": true,
                                    "selections": (v19/*: any*/)
                                  },
                                  (v20/*: any*/)
                                ],
                                "type": "AIOpsIncidentSuggestedAffectedServices"
                              }
                            ]
                          }
                        ],
                        "type": "AIOpsIncidentSuggestionResponse"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "limit",
                        "value": 5
                      }
                    ],
                    "concreteType": "AIOpsIncidentTimelineIccResponse",
                    "kind": "LinkedField",
                    "name": "incidentTimeline",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AIOpsIncidentTimelineIccEntry",
                        "kind": "LinkedField",
                        "name": "entries",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "timestamp"
                          }
                        ]
                      }
                    ],
                    "storageKey": "incidentTimeline(limit:5)"
                  }
                ]
              },
              {
                "condition": "isJsmIncidentCommandCenterEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "shouldShowIncidentCommandCenter"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeReleasesPanelDevOpsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v32/*: any*/)
          }
        ]
      },
      {
        "condition": "includeDesignPanelData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v31/*: any*/),
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": (v36/*: any*/)
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "providersWithDesignType",
                    "args": [
                      (v30/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                          "DESIGN"
                        ]
                      }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": (v36/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "consistentRead",
                        "variableName": "consistentRead"
                      }
                    ],
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "designs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*: any*/),
                                  (v27/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "liveEmbedUrl"
                                  },
                                  {
                                    "args": (v31/*: any*/),
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v12/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "DevOpsSupportedActions",
                                            "kind": "LinkedField",
                                            "name": "supportedActions",
                                            "plural": false,
                                            "selections": [
                                              (v34/*: any*/),
                                              (v33/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "DevOpsDesignProvider"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdated"
                                  },
                                  (v35/*: any*/),
                                  (v22/*: any*/),
                                  (v37/*: any*/)
                                ],
                                "type": "DevOpsDesign"
                              },
                              (v16/*: any*/),
                              (v37/*: any*/)
                            ]
                          },
                          (v12/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      (v37/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "workItemModernizationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v32/*: any*/)
      }
    ]
  },
  "params": {
    "id": "4415d0b1ab234ce7d01399eb3698f9271644ab95605bfc662594739a4f108021",
    "metadata": {},
    "name": "ConnectedToIssueAggQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentSummaryRelayProvidertsx": isJsmIncidentCommandCenterIncidentSummaryEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmIncidentCommandCenterIncidentTimelineRelayProvidertsx": isJsmIncidentCommandCenterIncidentTimelineEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsRemoveJswddFetchOperationEnabledRelayProvidertsx": removeDesignProviderTypeFilter_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcRemoveCtiaqConfigStateRelayProvidertsx": removeCtiaqConfigState_provider
    }
  }
};
})();

(node as any).hash = "25be85a918669eed186942dd600736a7";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
